import _ from 'underscore';

import BaseView from '../log-base/view';
import template from './list/template.html';
import Suggest from '../suggest/index';

export default BaseView.extend({
	template: _.template(template),

	// override
	initialize: function() {
		// create subview(s)
		this.participantSuggestView = new Suggest.Views.Main({
			el: '.js-participant',
			dataUrl: '/extranet/autocompleteparticipant'
		}).render();

		// call parent
		BaseView.prototype.initialize.call(this, arguments);
	}
});
